<div class="w-full min-w-0 pb-6" style="overflow-y: auto">
    <table class="annuluPressureTable">
        <tr>
            <th class="bg-Grey" colspan="6">ANNULUS PRESSURE MONITORING REPORT</th>
        </tr>
        <tr class="bg-Grey">
            <td>Time (min)</td>
            <td>
                PCP (psi) <br />
                A-annulus
            </td>
            <td>
                ICP (psi) <br />
                B-annulus
            </td>
            <td>
                SCP (psi) <br />
                C-annulus
            </td>
            <td>
                CCP (psi) <br />
                D-annulus
            </td>
            <td>THP (psi)</td>
        </tr>
        <ng-container *ngFor="
  let annulusPressure of cdftAnnulusPressureReportDetails.controls; 
  let i = index
">
            <tr>
                <td>{{ annulusPressure.get('time')?.value }}</td>

                <td>
                    <input type="number" class="text-center w-full" inputmode="decimal" autocomplete="off"
                        enterkeyhint="next" step="0.1" min="0" [formControl]="annulusPressure.get('pcpAAnnulusPsi')"
                         numericCellNav [rowIndex]="i" colKey="pcpAAnnulusPsi" [attr.data-row]="i"
                        data-col="pcpAAnnulusPsi" />
                </td>

                <td>
                    <input type="number" class="text-center w-full" inputmode="decimal" autocomplete="off"
                        enterkeyhint="next" step="0.1" min="0" [formControl]="annulusPressure.get('icpBAnnulusPsi')"
                         numericCellNav [rowIndex]="i" colKey="icpBAnnulusPsi" [attr.data-row]="i"
                        data-col="icpBAnnulusPsi" />
                </td>

                <td>
                    <input type="number" class="text-center w-full" inputmode="decimal" autocomplete="off"
                        enterkeyhint="next" step="0.1" min="0" [formControl]="annulusPressure.get('scpCAnnulusPsi')"
                         numericCellNav [rowIndex]="i" colKey="scpCAnnulusPsi" [attr.data-row]="i"
                        data-col="scpCAnnulusPsi" />
                </td>

                <td>
                    <input type="number" class="text-center w-full" inputmode="decimal" autocomplete="off"
                        enterkeyhint="next" step="0.1" min="0" [formControl]="annulusPressure.get('ccpDAnnulusPsi')"
                         numericCellNav [rowIndex]="i" colKey="ccpDAnnulusPsi" [attr.data-row]="i"
                        data-col="ccpDAnnulusPsi" />
                </td>

                <td>
                    <input type="number" class="text-center w-full" inputmode="decimal" autocomplete="off"
                        enterkeyhint="done" step="0.1" min="0" [formControl]="annulusPressure.get('thpPsi')"
                         numericCellNav [rowIndex]="i" colKey="thpPsi" [attr.data-row]="i"
                        data-col="thpPsi" />
                </td>
            </tr>
        </ng-container>
    </table>
</div>

<hr />
<div class="grid grid-cols-2 gap-6 w-full min-w-0">
    <table class="annulusPressureBleedOffTable">
        <tr>
            <td class="text-left" style="border: none" colspan="3">Remarks</td>
        </tr>
        <tr>
            <td class="bg-Grey" colspan="3">
                Annulus Pressure Bleed Off Requirements (psi)
            </td>
        </tr>
        <tr>
            <td><b>Type Of Well</b></td>
            <td><b>Natural Flow</b></td>
            <td><b>Gas Lifted</b></td>
        </tr>
        <tr>
            <td><b>PCP</b></td>
            <td>1000 psi</td>
            <td>NA</td>
        </tr>
        <tr>
            <td><b>ICP,SCP</b></td>
            <td>500 psi</td>
            <td>500 psi</td>
        </tr>
        <tr>
            <td><b>CCP</b></td>
            <td>200 psi</td>
            <td>200 psi</td>
        </tr>
    </table>
    <form [formGroup]="formGroup" class="grid grid-cols-1">
        <mat-label>Annulus to be tested</mat-label>
        <div class="mb-2">
            <mat-checkbox formControlName="pcp">PCP</mat-checkbox>
            <mat-checkbox formControlName="icp">ICP</mat-checkbox>
            <mat-checkbox formControlName="scp">SCP</mat-checkbox>
            <mat-checkbox formControlName="ccp">CCP</mat-checkbox>
        </div>

        <div class="my-2">
            <mat-form-field class="custom-mat-form-field w-full">
                <mat-label>Result</mat-label>
                <mat-select matNativeControl formControlName="result">
                    <mat-select-trigger class="rounded">
                        <span class="p-2 font-semibold" [ngClass]="{
                        'bg-good': formGroup.get('result')?.value === 'GOOD',
                        'bg-failed': formGroup.get('result')?.value === 'FAILED'
                      }">
                            {{ formGroup.get('result')?.value || 'Select Result' }}
                        </span>
                    </mat-select-trigger>

                    <mat-option value="GOOD">
                        <div class="bg-good p-2 rounded text-center text-black w-20">GOOD</div>
                    </mat-option>

                    <mat-option value="FAILED">
                        <div class="bg-failed p-2 rounded text-center text-black w-20">FAILED</div>
                    </mat-option>
                </mat-select>

                <!--                 
                <input type="text" matInput formControlName="result" [matAutocomplete]="result"
                   />
                <mat-autocomplete autoActiveFirstOption #result="matAutocomplete">
                    <mat-option value="GOOD">GOOD</mat-option>
                    <mat-option value="FAILED">FAILED</mat-option>
                </mat-autocomplete> -->
            </mat-form-field>
        </div>
        <div class="my-2">
            <mat-label>Remarks</mat-label>
            <mat-form-field class="custom-mat-form-field w-full">
                <input type="text" matInput formControlName="remarks" />
            </mat-form-field>
        </div>
    </form>
</div>